/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slots_TitleInputs */

const en_slots_title = /** @type {(inputs: Slots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal slots`)
};

const de_slots_title = /** @type {(inputs: Slots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahlzeiten`)
};

/**
* | output |
* | --- |
* | "Meal slots" |
*
* @param {Slots_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slots_title = /** @type {((inputs?: Slots_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slots_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slots_title(inputs)
	return en_slots_title(inputs)
});